import hasPermissions from './hasPermissions';

export default {
  hasPermissions,
};
